import 'inventory-listing/components/ListingHeader/ListingHeader.scss';

import React from 'react';
import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';
import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';

const ListingHeader = ({ title, colanderGroupSlug }) => {
    let content;
    let url;
    if (colanderGroupSlug === COLANDER_GROUPS.NEW) {
        content = ContentZonesService.getContentZone(
            'widget.listing.used',
            'widget.listing.used.buy.online.banner.new'
        );
        url = ContentZonesService.getContentZone(
            'widget.listing.used',
            'widget.listing.used.buy.online.banner.url.new'
        );
    } else {
        content = ContentZonesService.getContentZone('widget.listing.used', 'widget.listing.used.buy.online.banner');
        url = ContentZonesService.getContentZone(
            'widget.listing.used',
            'widget.listing.used.buy.online.banner.url.used'
        );
    }

    if (!content || !content.getValue()) {
        content = ContentZonesService.getContentZone('widget.listing.used', 'widget.listing.used.buy.online.banner');
        url = ContentZonesService.getContentZone(
            'widget.listing.used',
            'widget.listing.used.buy.online.banner.url.used'
        );
        if (!content || !content.getValue()) {
            return null;
        }
    }

    const banner =
        !url || !url.getValue() ? (
            <img src={content.getValue()} alt={LocaleService.t('HEADER_BANNER')} />
        ) : (
            <a target="_blank" rel="noopener noreferrer" href={url.getValue()}>
                <img src={content.getValue()} alt={LocaleService.t('HEADER_BANNER')} />
            </a>
        );

    return (
        <div className="listing-used-header">
            <div className="listing-used-banner">{banner}</div>
            <h1 className="sr-title-1 is-centered">{title}</h1>
        </div>
    );
};

ListingHeader.defaultProps = {
    colanderGroupSlug: COLANDER_GROUPS.DEFAULT,
};

ListingHeader.propTypes = {
    title: React.PropTypes.string.isRequired,
    colanderGroupSlug: React.PropTypes.string,
};

ListingHeader.displayName = 'ListingHeader';

export default ListingHeader;



// WEBPACK FOOTER //
// ./client/src/components/ListingHeader/ListingHeader.jsx